<template>
    <div v-if="!video.settings.live" class="card px-3 py-4 w-100">
        <h1 class="my-auto mx-auto">
            {{ $t('lesson.live.unavailable') }}
        </h1>
        <h3 class="mx-auto" v-if="video.settings.start_date">
            {{ $t('lesson.live.start_at') }}: {{ $moment(video.settings.start_date).format('LLL') }}
        </h3>
    </div>
    <Player v-else-if="video && url" :contentId="contentId" :video="url"/>
</template>

<script>
import Player from '../../Common/Player';
import { NCH_ENV } from '../../../../../js/nch-env';

export default {
    emits: ['input', 'update:modelValue', 'value'],
    name: 'ContentLive',
    // A aula (LessonContentVideo) entrega `:video` com o objeto do vídeo a todos os tipos.
    // Este componente não declara essa prop e sua raiz é o <Player>: no Vue 3 o atributo
    // não declarado é repassado à raiz e sobrescrevia o `:video="url"` — o iframe ia para
    // player/[object Object] ("URL inválida", backlog#340). Aqui nada é repassado.
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Object,
        },
        contentId: {
            type: Number,
            required: true,
        },
    },
    components: {
        Player,
    },
    computed: {
        user() {
            return this.$store.getters.USER;
        },
        evtUrl() {
            if (this.video.type_video === 'EVT') {
                const evtIndex = this.video.settings.live_data.shareLink.indexOf('evt');

                if (evtIndex !== -1) {
                    return this.video.settings.live_data.shareLink.substring(evtIndex);
                }
                return this.video.settings.live_data.shareLink;
            }
        },
        url() {
            return this.video.type_video === 'EVT'
                ? this.evtUrl
                : `${this.video.type_video}/${this.video.secret}`;
        },
        live: {
            get() {
                return {
                    room_id: this.video.settings.id,
                    name: `NCH_LV_${this.video.settings.id}`,
                    status: this.video.settings.chat,
                    history: this.video.settings.chat_save,
                    moderate: this.video.settings.chat_mod,
                    type: 'lv',
                };
            },
            set(settings) {
                this.$emit('value', {
                    ...this.video,
                    settings: {
                        room_id: settings.id,
                        name: `NCH_LV_${settings.id}`,
                        status: settings.chat,
                        history: settings.chat_save,
                        moderate: settings.chat_mod,
                        type: 'lv',
                    },
                });
            },

        },
        video: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('value', value);
            },
        },
    },
    methods: {
        subscribe() {
            window.Echo
                .private(`${NCH_ENV.APP_HOST}.Lesson.Live.${this.video.settings.id}`)
                .listen('LiveLessonEvent', (e) => {
                    if (e.settings) {
                        this.live = e.settings;
                    }
                });
        },
    },
    watch: {
        'video.settings.id': {
            handler(value) {
                this.subscribe();
            },
        },
    },
    mounted() {
        this.subscribe();
    },
};
</script>

<style>

</style>
